import AdBrickConfig from '../models/ad-brick-config';
import LeaderBoardBrickConfig from '../models/leaderboard-brick-config';
import PosterBrickConfig from '../models/poster-brick-config';
import WidgetV2BrickConfig from '../models/widget-v2-brick-config';
import PublisherBrickConfig from '../models/publisher-brick-config';

const brickConfigClassMap = {
  poster: PosterBrickConfig,
  'widget-v2': WidgetV2BrickConfig,
  'iab-300x250': AdBrickConfig,
  'iab-leaderboard': LeaderBoardBrickConfig,
  publisher: PublisherBrickConfig,
};

export default class BrickConfigClassMap {
  static get(brickType) {
    return brickConfigClassMap[brickType] || PosterBrickConfig;
  }
}



// WEBPACK FOOTER //
// ./src/utils/brick_config_class_map.js